import { mapGetters } from "vuex";
import LayoutSidebar from "@/layouts/LayoutSidebar/LayoutSidebar.vue";
import { isSmallDevice } from "@/common/functions";
import SynonymFilter from "@/components/Synonym/SynonymFilter/SynonymFilter.vue";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    components: {
        Advertising,
        Breadcrumb: () =>
            import(/* webpackChunkName: "creadcrumb" */ "@/components/Breadcrumb/Breadcrumb.vue"),
        LayoutSidebar,
        SentencesExamples: () =>
            import(
                /* webpackChunkName: "sentencesExamples" */ "@/components/SentencesExamples/SentencesExamples.vue"
            ),
        RelatedArticles: () =>
            import(
                /* webpackChunkName: "relatedArticles" */ "@/components/RelatedArticles/RelatedArticles.vue"
            ),
        MentionedIn: () =>
            import(
                /* webpackChunkName: "mentionedIn" */ "@/components/MentionedIn/MentionedIn.vue"
            ),
        NearSynonyms: () =>
            import(
                /* webpackChunkName: "nearSynonyms" */ "@/components/NearSynonyms/NearSynonyms.vue"
            ),
        SynonymFilter,
        SynonymList: () =>
            import(
                /* webpackChunkName: "synonymList" */ "@/components/Synonym/SynonymList/SynonymList.vue"
            ),
        OtherForms: () =>
            import(
                /* webpackChunkName: "otherForms" */ "@/components/Synonym/OtherForms/OtherForms.vue"
            ),
        SynonymStudy: () =>
            import(
                /* webpackChunkName: "synonymStudy" */ "@/components/Synonym/SynonymStudy/SynonymStudy.vue"
            ),
        AZSortingToggle: () =>
            import(
                /* webpackChunkName: "azsortingToggle" */ "@/components/Synonym/AZSortingToggle/AZSortingToggle.vue"
            ),
        SaveWordPopup: () =>
            import(
                /* webpackChunkName: "saveWordPopup" */ "@/components/SaveWordPopup/SaveWordPopup.vue"
            )
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            layout: LayoutSidebar
        };
    },
    computed: {
        isSmallDevice,
        mobileReuseAds() {
            return [
                "Mobile_Thesaurus_Detail_InContent_Top",
                "Mobile_Thesaurus_Detail_InContent_Middle"
            ];
        },
        word() {
            return `<span class="emphasis">${this.getThesaurusHeadword}</span>`;
        },
        ...mapGetters([
            "getThesaurusHeadword",
            "getThesaurus",
            "getSortedAZThesaurus",
            "isPosFilterActive",
            "isAZFilterActive",
            "isThesaurusLoaded",
            "isAntonymFilterActive",
            "isVisibleSaveWordPopup"
        ])
    },
    methods: {
        loadThesaurus() {
            this.$store.dispatch("loadThesaurus", {
                slug: this.$route.params.slug,
                component: this
            });
        },
        getMobileAd(index) {
            return index >= 0 && index < this.mobileReuseAds.length
                ? this.mobileReuseAds[index]
                : "";
        },
        hasMobileAdAt(index) {
            return index >= 0 && index < this.mobileReuseAds.length;
        },
        capitalize(data) {
            return data.charAt(0).toUpperCase() + data.slice(1);
        }
    },
    mounted() {
        this.loadThesaurus();
    },
    beforeRouteUpdate(to, from, next) {
        next();
        this.loadThesaurus();
    },
    metaInfo() {
        const word = this.getThesaurusHeadword;
        return {
            title: this.$t(`thesaurusDetailPageTitle`, { word: `${word}` }),
            meta: [
                {
                    name: "description",
                    content: this.$t(`thesaurusDetailPageMetaDescription`, { word: `${word}` })
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://thesaurus.yourdictionary.com/${word}`
                }
            ]
        };
    },
    created() {
        if (typeof window.__PRERENDER_INJECTED === "undefined") {
            hj("trigger", "test");
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/Synonyms/Detail/SynonymDetail.js